import { createContext } from 'react';

type ContextType = {
  isLoading: boolean;
  setIsLoading: (value: boolean) => void;
};

const MainContextProvider = createContext<ContextType>({
  isLoading: false,
  setIsLoading: () => {},
});

export default MainContextProvider;
